import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import * as Colors from 'src/theme/colors';
import { DividersAndCardBorders } from 'src/theme/colors';

import { FormPageHeaderProps } from '../formPageTypes';

import FormPageHeaderBase from './FormPageHeaderBase';

const useStyles = makeStyles()(() => ({
  containedPageHeader: {
    borderBottom: `1px solid ${DividersAndCardBorders}`,
  },
  unsavedChanges: {
    backgroundColor: Colors.HoverBackground,
  },
}));

const ContainedFormPageHeader: React.FC<FormPageHeaderProps> = (props) => {
  const { classes } = useStyles();
  const { showActions } = props;
  return (
    <FormPageHeaderBase
      className={clsx(classes.containedPageHeader, {
        [classes.unsavedChanges]: showActions,
      })}
      {...props}
    />
  );
};

export default ContainedFormPageHeader;
